/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Moje objednávky`
};

const da_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Mine ordrer`
};

const de_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Meine Bestellungen`
};

const en_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `My orders`
};

const es_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Mis pedidos`
};

const fr_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Mes commandes`
};

const hu_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Rendeléseim`
};

const it_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `I miei ordini`
};

const nl_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Mijn bestellingen`
};

const pl_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Moje zamówienia`
};

const pt_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Meus pedidos`
};

const sv_my_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Mina beställningar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const my_orders = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.my_orders(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("my_orders", locale)
	if (locale === "cs") return cs_my_orders(inputs)
	if (locale === "da") return da_my_orders(inputs)
	if (locale === "de") return de_my_orders(inputs)
	if (locale === "en") return en_my_orders(inputs)
	if (locale === "es") return es_my_orders(inputs)
	if (locale === "fr") return fr_my_orders(inputs)
	if (locale === "hu") return hu_my_orders(inputs)
	if (locale === "it") return it_my_orders(inputs)
	if (locale === "nl") return nl_my_orders(inputs)
	if (locale === "pl") return pl_my_orders(inputs)
	if (locale === "pt") return pt_my_orders(inputs)
	return sv_my_orders(inputs)
};